import {useSelector} from "react-redux";
import moment from "moment";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {useTranslation} from "react-i18next";
import Loading from "../loading";
import './index.css'
import SvgIcon from "../svg-icon";
import {Tooltip} from "react-tooltip";
import NoData from "../no-data";
import Big from "big.js";
import InstrumentIcon from "../instrument-icon";
import RankIcon from "../rank-icon";
import SkeletonSliderItem from "../skeleton/slider";

const UserProgress = props => {

    let {username} = props
    const {user} = useSelector(state => state.authenticationReducer)

    const [stateUsername, setStateUsername] = useState('')


    const {t} = useTranslation()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const [data, setData] = useState({})

    useEffect(() => {
        setStateUsername(username ?? user?.username)
    }, [username, user?.username])

    useEffect(() => {
        if (stateUsername) {
            associateServices.getVipState({
                username: stateUsername
            }).then(res => {
                if (res?.status === 200) {
                    setData(res?.data)
                } else {
                    setError(res?.errors)
                }
                setLoading(false)
            })
        }

    }, [stateUsername])

    return (
        // loading ? <Loading/> :
        loading  ? <SkeletonSliderItem/> :
            error ?
                <NoData desc={t(`api-notifications.${error}`)}/>
                :
                <div className="progress-wrapper home-progress container" id="vip-user-progress">
                    <div className="modal__profile">


                        <div className="d-flex align-items-center gap-2">
                            {
                                data?.current?.icon &&

                                <div className="modal__icon">

                                    <Tooltip anchorSelect={`#current-rank`} className="tooltip-me">

                                    <span className="gap-2">
                                        {/*<RankIcon icon={data?.current?.icon}/>*/}
                                        {data?.current?.name}
                                    </span>

                                    </Tooltip>

                                    <span id="current-rank">
                                {/*<SvgIcon id={data.rank}/>*/}
                                        <RankIcon icon={data?.current?.icon}/>
                            </span>
                                </div>
                            }

                            <div className="modal__user">
                                <p>{data?.username}</p>
                                <span>{moment.unix(data?.registration).format("MMM Do YY")}</span>
                            </div>
                        </div>
                    </div>
                    <div className="modal__progress">
                        <div className="modal__progress-text">
                            <span>{t('modals.vip.progress.title')}</span>
                            <span>{Big(data?.percentage || 0).toFixed(2)}%</span>
                        </div>
                        <div className="modal__progress-bar">
                            <span style={{width: `${parseInt(data?.percentage || 0)}%`}}/>
                        </div>
                        <div className="modal__progress-text modal__progress-text--white">

                             <span className="d-flex align-items-center gap-2">
                                    <Tooltip className="tooltip-me" anchorSelect={`#now2-rank`}>
                                        <span className="gap-2">
                                            {data?.current?.name}
                                        </span>
                                    </Tooltip>

                                    <span id="now2-rank" className="d-flex gap-2">
                                        {/*<SvgIcon id={data?.current?.slug}/>*/}
                                        {
                                            data?.current?.icon &&
                                            <RankIcon icon={data?.current?.icon}/>
                                        }

                                        <span>
                                            {data?.current?.name}
                                            {/*{t(`modals.vip.progress.${data?.current?.slug}`)}*/}
                                         </span>
                                    </span>
                            </span>


                            <span className="d-flex align-items-center gap-2">


                                    <Tooltip className="tooltip-me" anchorSelect={`#next-rank`}>
                                        <span className="row-gap-2">
                                            {/*<SvgIcon id={data.next?.slug}/>*/}
                                            {/*<RankIcon icon={data?.next?.icon}/>*/}
                                            {data?.next?.name}

                                            {/*{t(`modals.vip.progress.${data?.next?.slug}`)}*/}
                                        </span>
                                    </Tooltip>

                                    <span id="next-rank" className="d-flex gap-2">

                                    <span>
                                    {data?.next?.name}
                                        {/*{t(`modals.vip.progress.${data?.next?.slug}`)}*/}
                                    </span>

                                        <RankIcon icon={data?.next?.icon}/>
                                        {/*<SvgIcon id={data?.next?.slug}/>*/}
                                    </span>
                            </span>


                        </div>
                    </div>
                </div>
    )

}

export default UserProgress
